export default __webpack_public_path__ + "guide--vector-tiles-standards-cw-960-d0f59afb0ee3e47f04dc6303e523677f.png";